import React, { useEffect } from "react";
import { Type } from "discover.medical.react-component-library";
import { log } from "../../telemetry/analytics";
import { ECOMMERCE_PRODUCT_LIST_VIEWED } from "../../telemetry/constants";
import { handleAnalyticsConsent } from "../../osano";
import { productBullets, premiumPlanIds } from "../../constants/products";
import {
  Bullet,
  Bullets,
  BulletIcon,
  Container,
  Intro,
  IntroContent,
  Tiles,
  Tile,
  Logo,
  Title,
} from "./Storefront.styled";
import Spinner from "../Spinner";
import KlasLogo from "../../assets/svg/klas-2025.svg";

const Storefront = ({ products, productCode, productName }) => {
  useEffect(() => {
    handleAnalyticsConsent(() => log(ECOMMERCE_PRODUCT_LIST_VIEWED, {}));
  }, []);

  const isDynaAIAvailable = (products) => {
    return products.some(
      (product) => product.productOfferingId === premiumPlanIds[productCode],
    );
  };

  const showFreeTrial = (product) => {
    return (
      !isDynaAIAvailable(products) ||
      product.productOfferingId === premiumPlanIds[productCode]
    );
  };

  const showKlas = productCode === "dmp";
  const bullets = productBullets[productCode];
  const introContent = () => {
    if (productCode === "dmx") {
      return (
        <Type color="white" element="i" fontSize="xl">
          Combines two{" "}
          <Type color="white" fontWeight="semibold" element="i" fontSize="xxl">
            Best in KLAS
          </Type>{" "}
          solutions, DynaMed
          <Type element="sup">
            <Type fontSize="xs" color="white" element="span">
              &reg;
            </Type>
          </Type>{" "}
          and Micromedex
          <Type element="sup">
            <Type fontSize="xs" color="white" element="span">
              &reg;
            </Type>
          </Type>
          , to bring clinicians the most comprehensive clinical decision support
          solution.
        </Type>
      );
    } else {
      return (
        <Type color="white" element="i" fontSize="xl">
          <Type color="white" fontWeight="semibold" element="i" fontSize="xxl">
            2025 Best in KLAS
          </Type>{" "}
          winner for Point-of-Care Disease Reference - designed to help
          clinicians make informed decisions.
        </Type>
      );
    }
  };

  return (
    <Container>
      <Title element="h1" fontWeight="light" color="white" marginBottom="sm">
        Subscribe to {productName}
      </Title>
      <Intro container marginBottom="xl">
        {showKlas && <Logo src={KlasLogo} />}
        <IntroContent>
          <Type element="p" marginBottom="sm">
            {introContent()}
          </Type>
          <Bullets>
            {bullets?.map((bullet, idx) => (
              <Bullet key={`bullet-${idx}`}>
                <BulletIcon
                  icon={{
                    glyph: "check_circle",
                    size: "md",
                  }}
                />{" "}
                <Type color="white" element="span">
                  {bullet}
                </Type>
              </Bullet>
            ))}
          </Bullets>
        </IntroContent>
      </Intro>
      {products ? (
        <Tiles container wrap marginBottom="lg">
          {products.map((product) => (
            <Tile
              key={product.id}
              plan={product}
              showFreeTrial={showFreeTrial(product)}
              productCode={productCode}
              productName={productName}
            />
          ))}
        </Tiles>
      ) : (
        <Spinner />
      )}
      <Type fontSize="sm" color="white" element="p" marginBottom="sm">
        Please note that{" "}
        <Type fontSize="sm" color="white" element="i">
          {productName} with Dyna AI
        </Type>{" "}
        for individual subscribers is currently only available in the USA.
      </Type>
      <Type fontSize="sm" color="white">
        * Pricing is in US Dollars
      </Type>
    </Container>
  );
};

export default Storefront;
